import ReactPaginate from "react-paginate";

function Pagination({ currentPage, pageCount, paginationHandler }) {
  return (
    <>
      <style jsx global>{`
        .pagination {
          display: flex;
          justify-content: center;
          list-style: none;
          cursor: pointer;
        }
        .pagination a {
          padding: 10px;
          border-radius: 5px;
          border: 1px solid #8c59ea;
          color: #8c59ea;
          display: inline-block;
          min-width: 42px;
          text-align: center;
          margin: 0 1px;
        }
        .pagination__link {
          font-weight: bold;
        }
        .pagination__link--active a {
          color: #fff;
          background: #8c59ea;
        }
        .pagination__link--disabled a {
          color: rgb(198, 197, 202);
          border: 1px solid rgb(198, 197, 202);
        }
      `}</style>
      <ReactPaginate
        previousLabel={'<'}
        nextLabel={'>'}
        breakLabel={'...'}
        breakClassName={'break-me'}
        containerClassName={"pagination"}
        previousLinkClassName={"pagination__link"}
        nextLinkClassName={"pagination__link"}
        disabledClassName={"pagination__link--disabled"}
        activeClassName={"pagination__link--active"}
        initialPage={currentPage - 1}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={paginationHandler}
      />
    </>
  );
}

export default Pagination;
